<form class="f-col blank-form" [formGroup]="documentinfoForm">
  <div class="section-heading">
    <h2 class="h2-heading">
      {{ content?.["b2b.managetraveler.docinfo"] }}
      <div class="dot">.</div>
      <span class="optional">{{
        content?.["b2b.managetraveler.optional"]
        }}</span>
    </h2>
    <a role="button" class="link" *ngIf="
        dataSource1?.data?.length && !Addnew && canShowDocumentActions && filteredDocumentTypes?.length > 0
      " (click)="handleEvent('document-info')"><mat-icon fontSet="material-symbols-outlined"
        class="add-icon">add</mat-icon>{{
      content?.["b2b.managetraveler.addnewdoc"] }}</a>
  </div>
  <div class="section-content">
    <div class="inner-contentsection">
      <div *ngIf="dataSource1.data.length == 0 || Addnew" class="f-col form-listing">
        <div class="f-row two--ColLayout">
          <div class="f-col">
            <ng-select [items]="countriesLists" groupBy="group" [searchFn]="_CommonService.customCountrySearchFn"
              formControlName="countryControl0" bindValue="isoCode"
              [placeholder]="content?.['b2b.managetraveler.nationality']"
              (keypress)="_CommonService.allowOnlyCharacters($event)" (paste)="_CommonService.onPasteBlocked($event)"
              (contextmenu)="_CommonService.disableRightClick($event)" data-dd-privacy="mask"
              [disabled]="!canShowDocumentActions">
              <ng-template ng-optgroup-tmp let-item="item">
                {{ item.group }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <span class="ng-option-label">
                  <ng-container *ngIf="!!item?.newFlag?.src">
                    <img [src]="getImageUrl(item?.newFlag?.src)" alt="Flag of {{ item.countryName }}" class="flag-img"
                      [height]="item.height" [width]="item.width" />
                  </ng-container>
                  {{ item.countryName }}
                </span>
              </ng-template>
              <ng-template ng-label-tmp let-item="item">
                <span class="ng-value-label"> {{ item?.countryName }} </span>
              </ng-template>
              <ng-template ng-notfound-tmp>
                <div class="no-items-found">
                  <img src="assets/images/not-found.png" alt="No items found" class="no-items-image" />
                  <p>{{content?.dictionary?.['b2b.managetraveler.nocountryfound']}}</p>
                </div>
              </ng-template>
            </ng-select>
            <mat-error class="px-4" *ngIf="
                documentinfoForm.get('countryControl0')?.hasError('required') &&
                documentinfoForm.get('countryControl0')?.touched
              ">
              {{content?.dictionary?.['b2b.managetraveler.countryreq']}}
            </mat-error>
            <mat-error *ngIf="
                documentinfoForm
                  .get('countryControl0')
                  ?.hasError('InvalidInput') &&
                documentinfoForm.get('countryControl0')?.touched
              ">
              {{content?.dictionary?.['b2b.managetraveler.selectvalidnationality']}}
            </mat-error>
          </div>
          <div class="f-col">
            <ng-select [items]="countriesLists" groupBy="group" [searchFn]="_CommonService.customCountrySearchFn"
              formControlName="placeOfResidence" bindValue="isoCode" placeholder="Place of residence"
              (change)="changeCountry($event)" (keypress)="_CommonService.allowOnlyCharacters($event)" data-dd-privacy="mask"
              [disabled]="!canShowDocumentActions">
              <ng-template ng-optgroup-tmp let-item="item">
                {{ item.group }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <span class="ng-option-label">
                  <ng-container *ngIf="!!item?.newFlag?.src">
                    <img [src]="getImageUrl(item?.newFlag?.src)" alt="Flag of {{ item.countryName }}" class="flag-img"
                      [height]="item.height" [width]="item.width" />
                  </ng-container>
                  {{ item.countryName }}
                </span>
              </ng-template>
              <ng-template ng-label-tmp let-item="item">
                <span class="ng-value-label"> {{ item?.countryName }} </span>
              </ng-template>
              <ng-template ng-notfound-tmp>
                <div class="no-items-found">
                  <img src="assets/images/not-found.png" alt="No items found" class="no-items-image" />
                  <p>{{content?.dictionary?.['b2b.managetraveler.nocountryfound']}}</p>
                </div>
              </ng-template>
            </ng-select>
            <mat-error class="px-4" *ngIf="
                documentinfoForm
                  .get('placeOfResidence')
                  ?.hasError('required') &&
                documentinfoForm.get('placeOfResidence')?.touched
              ">
              {{content?.dictionary?.['b2b.managetraveler.countryreq']}}
            </mat-error>
            <mat-error *ngIf="
                documentinfoForm
                  .get('placeOfResidence')
                  ?.hasError('InvalidInput') &&
                documentinfoForm.get('placeOfResidence')?.touched
              ">
              {{content?.dictionary?.['b2b.register.validcountryname']}}
            </mat-error>
          </div>
        </div>

        <div class="f-row two--ColLayout">
          <div class="f-col">
            <mat-form-field appearance="fill" [disabled]="!canShowDocumentActions">
              <mat-label>{{
                content?.["b2b.managetraveler.doctype"]
                }}</mat-label>
              <mat-icon fontSet="material-symbols-outlined" matSuffix>stat_minus_1</mat-icon>
              <mat-select formControlName="DocType" (selectionChange)="onDocTypeChange($event.value)" data-dd-privacy="mask">
                <mat-option *ngFor="let type of filteredDocumentTypes" [value]="type.value">
                  {{ type.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="
                  documentinfoForm.get('DocType')?.hasError('required') &&
                  documentinfoForm.get('DocType')?.touched
                ">
                {{content?.dictionary?.['b2b.booking.doctypereq']}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="f-row">
          <div class="f-col">
            <h3 class="h3-heading">
              {{ documentTypesObj[documentinfoForm.value.DocType]?.heading }}
            </h3>
          </div>
        </div>
        <div class="f-row two--ColLayout">
          <div class="f-col">
            <mat-form-field appearance="fill" [disabled]="!canShowDocumentActions">
              <!-- Dynamic Label -->
              <mat-label>
                {{ documentTypesObj[documentinfoForm.value.DocType]?.input }}
              </mat-label>

              <!-- Input Field -->
              <input matInput formControlName="Passportno" (keypress)="blockInvalidCharacters($event)"
                (paste)="_CommonService.onPasteBlocked($event)"
                (contextmenu)="_CommonService.disableRightClick($event)" (blur)="verifyDuplicateDocID()" data-dd-privacy="mask"/>

              <!-- Required Error -->
              <mat-error *ngIf="documentinfoForm.get('Passportno')?.hasError('required')">
                {{ documentTypesObj[documentinfoForm.value.DocType]?.input }} is
                required.
              </mat-error>

                <mat-error *ngIf="documentinfoForm.get('Passportno')?.hasError('duplicatedoc')">
                Document number already exists.
              </mat-error>

              <mat-error *ngIf="documentinfoForm.get('Passportno')?.hasError('apiError')">
                {{content?.dictionary?.['b2b.register.InvalidIdNumber'] || 'Id number is invalid.'}}
              </mat-error>

              <!-- Pattern Error (Handles length + format) -->
              <mat-error *ngIf="documentinfoForm.get('Passportno')?.hasError('pattern')">
                <ng-container [ngSwitch]="documentinfoForm.get('DocType')?.value">
                  <!-- TSA -->
                  <ng-container *ngSwitchCase="'T'">
                    {{content?.dictionary?.['b2b.register.InvalidIdNumber'] || 'TSA Precheck number must be exactly 9 digits.'}}
                  </ng-container>

                  <!-- Redress -->
                  <ng-container *ngSwitchCase="'R'">
                    {{ content?.['phrases.b2b.managetraveler.redressnoexactlimit'] }}
                  </ng-container>

                  <!-- National ID -->
                  <ng-container *ngSwitchCase="'A'">
                    {{content?.dictionary?.['b2b.managetraveler.nationalidexactlimit'] || 'National ID must be exactly 10 digits and should start with 1.'}}
                  </ng-container>

                  <!-- IQAMA -->
                  <ng-container *ngSwitchCase="'I'">
                    {{content?.dictionary?.['b2b.managetraveler.iqamaexactlimit'] || 'Iqama must be exactly 10 digits and should start with 2.'}}
                  </ng-container>

                  <!-- Passport -->
                  <ng-container *ngSwitchCase="'P'">
                    {{content?.dictionary?.['passenger.Incorrectpassportno']}}
                  </ng-container>
                </ng-container>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="f-col" *ngIf="!isPrecheckOrRedress" [class.view-disabled]="isElmVerified">
            <mat-form-field appearance="fill" (click)="showComponent0('isDOBCalendarVisible0')">
              <mat-label>{{ content?.["b2b.managetraveler.dob"] }}</mat-label>
              <input matInput formControlName="DOB" [value]="selectedDOB0 ? (selectedDOB0 | date: 'dd/MM/y') : ''"
                [placeholder]="content?.['b2b.managetraveler.dob']" autocomplete="off"
                (keypress)="_CommonService.blockInvalidCharactersForDOB($event)"
                (contextmenu)="disableRightClick($event)" (paste)="onPasteBlocked($event)" readonly data-dd-privacy="mask" />
              <mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
              <mat-error *ngIf="
                  documentinfoForm.get('DOB')?.hasError('required') &&
                  documentinfoForm.get('DOB')?.touched
                ">
                {{content?.dictionary?.['b2b.managetraveler.selectdob']}}
              </mat-error>
            </mat-form-field>
            <app-date-ofbirth *ngIf="isChildVisible0['isDOBCalendarVisible0']" [disabled]="isDisableDateOfBirth0"
              (confirm)="onConfirm0('isDOBCalendarVisible0')" (dateSelected)="onDateSelected0($event)"
              [PassengerTypeCode]="'ADT'" class="datepicker-content-container" data-dd-privacy="mask">
            </app-date-ofbirth>
          </div>
        </div>
        <div class="f-row two--ColLayout" *ngIf="!isPrecheckOrRedress">
          <div class="f-col">
            <ng-select [items]="countriesLists" groupBy="group" [searchFn]="_CommonService.customCountrySearchFn"
              formControlName="issueCountry" bindValue="isoCode" placeholder="Issue Country"
              (change)="changeCountry($event)" (keypress)="_CommonService.allowOnlyCharacters($event)" data-dd-privacy="mask">
              <ng-template ng-optgroup-tmp let-item="item">
                {{ item.group }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <span class="ng-option-label">
                  <ng-container *ngIf="!!item?.newFlag?.src">
                    <img [src]="getImageUrl(item?.newFlag?.src)" alt="Flag of {{ item.countryName }}" class="flag-img"
                      [height]="item.height" [width]="item.width" />
                  </ng-container>
                  {{ item.countryName }}
                </span>
              </ng-template>
              <ng-template ng-label-tmp let-item="item">
                <span class="ng-value-label"> {{ item?.countryName }} </span>
              </ng-template>
              <ng-template ng-notfound-tmp>
                <div class="no-items-found">
                  <img src="assets/images/not-found.png" alt="No items found" class="no-items-image" />
                  <p>{{content?.dictionary?.['b2b.managetraveler.nocountryfound']}}</p>
                </div>
              </ng-template>
            </ng-select>
            <mat-error class="px-4" *ngIf="
                documentinfoForm.get('issueCountry')?.hasError('required') &&
                documentinfoForm.get('issueCountry')?.touched
              ">
              {{content?.dictionary?.['b2b.managetraveler.countryreq']}}
            </mat-error>
            <mat-error *ngIf="
                documentinfoForm
                  .get('issueCountry')
                  ?.hasError('InvalidInput') &&
                documentinfoForm.get('issueCountry')?.touched
              ">
              {{content?.dictionary?.['b2b.managetraveler.selectvalidnationality']}}
            </mat-error>
          </div>
          <div class="f-col">
            <ng-select [items]="commonObjPipes.cities" formControlName="passportPOI"
              [placeholder]="content?.['b2b.managetraveler.placeofissue']" bindLabel="cityName" bindValue="cityName"
              (keypress)="_CommonService.allowOnlyCharacters($event)"
              (paste)="_CommonService.onPasteBlocked($event)" (contextmenu)="_CommonService.disableRightClick($event)"
              [notFoundText]="content?.['b2b.managetraveler.noplaceofissue']" data-dd-privacy="mask"></ng-select>
            <mat-error class="px-4" *ngIf="
                documentinfoForm.get('passportPOI')?.hasError('required') &&
                documentinfoForm.get('passportPOI')?.touched
              ">
              {{content?.['b2b.managetraveler.placeofissue']}} is required.
            </mat-error>
          </div>
        </div>
        <div class="f-row two--ColLayout" *ngIf="!isPrecheckOrRedress">
          <div class="f-col position-relative">
            <mat-form-field appearance="fill" (click)="showComponent1('isDOBCalendarVisible1')">
              <mat-label>{{ content?.["b2b.managetraveler.validfrom"] }} (Optional)
              </mat-label>
              <input matInput formControlName="Validfromdate" [placeholder]="content?.dictionary?.['b2b.managetraveler.selectvalidfromdate'] || 'Select your valid from date'" [value]="
                  selectedvalidatedate
                    ? (selectedvalidatedate | date: 'dd/MM/y')
                    : ''
                " autocomplete="off" (keypress)="_CommonService.blockInvalidCharacters($event)"
                (paste)="pasteControlHTMLTags($event)" readonly data-dd-privacy="mask" />
              <mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
              <mat-error *ngIf="
                  documentinfoForm.get('Validfromdate')?.hasError('required') &&
                  documentinfoForm.get('Validfromdate')?.touched
                ">
                {{content?.dictionary?.['b2b.managetraveler.pleaseselectvalidfromdate']}}
              </mat-error>
            </mat-form-field>
            <app-date-ofbirth *ngIf="isChildVisible1['isDOBCalendarVisible1']" [disabled]="isDisableDateOfBirth0"
              (confirm)="onConfirm1('isDOBCalendarVisible1')" (dateSelected)="onDateSelected1($event)"
              [PassengerTypeCode]="'ADT'" [selectedDOBDateFromParent]="selectedDOB0"
              class="datepicker-content-container" data-dd-privacy="mask">
            </app-date-ofbirth>
          </div>
          <div class="f-col position-relative open-calendar-bottom">
            <mat-form-field appearance="fill" (click)="showComponent2('isDOBCalendarVisible2')">
              <mat-label>{{
                content?.["b2b.managetraveler.expirydate"]
                }}</mat-label>
              <input matInput formControlName="ExpiryDate" [placeholder]="content?.dictionary?.['b2b.register.selectexpirydate'] || 'Select your expiry date'" [value]="
                  selectedExpiryDate
                    ? (selectedExpiryDate | date: 'dd/MM/y')
                    : ''
                " autocomplete="off" (keypress)="_CommonService.blockInvalidCharacters($event)"
                (paste)="pasteControlHTMLTags($event)" readonly data-dd-privacy="mask" />
              <mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
              <mat-error *ngIf="
                  documentinfoForm.get('ExpiryDate')?.hasError('required') &&
                  documentinfoForm.get('ExpiryDate')?.touched
                ">
                {{content?.dictionary?.['b2b.register.selectexpirydate']}}
              </mat-error>
            </mat-form-field>
            <app-expiry-date *ngIf="isChildVisible2['isDOBCalendarVisible2']"
              (confirm)="onConfirm2('isDOBCalendarVisible2')" [filledDate]="
                selectedExpiryDate ? (selectedExpiryDate | date: 'dd/MM/y') : ''
              " [key]="'isDOBCalendarVisible2'" [passengerTravelerCode]="'ADT'" [bypassDate]="false"
              (dateSelected)="onDateSelected2($event, 'isDOBCalendarVisible2')" data-dd-privacy="mask"
              [maxYearLimit]="docExpiryMaxYears" [useCurrentDateAsMin]="true">
            </app-expiry-date>
          </div>
        </div>
      </div>
      <div *ngIf="dataSource1?.data?.length && !Addnew" class="section-table data-listing">
        <table mat-table [dataSource]="dataSource1" class="mat-elevation-z0">
          <ng-container matColumnDef="DocType">
            <th mat-header-cell *matHeaderCellDef>
              {{ content?.["b2b.managetraveler.doctype"] }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{
              element.docType?.toUpperCase() === "P"
              ? "Passport"
              : element.docType?.toUpperCase() === "A"
              ? "National ID"
              : element.docType?.toUpperCase() === "I"
              ? "IQAMA Number"
              : ""
              }}
            </td>
          </ng-container>
          <ng-container matColumnDef="DocNo">
            <th mat-header-cell *matHeaderCellDef>
              {{ content?.["b2b.managetraveler.docnumber"] }}
            </th>
            <td mat-cell *matCellDef="let element" data-dd-privacy="mask">{{ element.docNo }}</td>
          </ng-container>
          <ng-container matColumnDef="dob">
            <th mat-header-cell *matHeaderCellDef>
              {{ content?.["b2b.managetraveler.dob"] }}
            </th>
            <td mat-cell *matCellDef="let element" data-dd-privacy="mask">
              {{ formatDateToCustomFormat(element.docDOB) }}
            </td>
          </ng-container>
          <ng-container matColumnDef="nationality">
            <th mat-header-cell *matHeaderCellDef>
              {{ content?.["b2b.managetraveler.nationality"] }}
            </th>
            <td mat-cell *matCellDef="let element" data-dd-privacy="mask">
              {{ getCountryNameByCode(element.nationality) }}
            </td>
          </ng-container>
          <ng-container matColumnDef="placeOfIssue">
            <th mat-header-cell *matHeaderCellDef>{{ content?.["b2b.managetraveler.placeofissue"] }}</th>
            <td mat-cell *matCellDef="let element" data-dd-privacy="mask">{{ element.poi }}</td>
          </ng-container>
          <ng-container matColumnDef="validFrom">
            <th mat-header-cell *matHeaderCellDef>
              {{ content?.["b2b.managetraveler.placeofissue"] }}
            </th>
            <td mat-cell *matCellDef="let element" data-dd-privacy="mask">
              {{ formatDateToCustomFormat(element.docIssueDate) }}
            </td>
          </ng-container>
          <ng-container matColumnDef="expiryDate">
            <th mat-header-cell *matHeaderCellDef>
              {{ content?.["b2b.managetraveler.expirydate"] }}
            </th>
            <td mat-cell *matCellDef="let element" data-dd-privacy="mask">
              {{ formatDateToCustomFormat(element.docExpiryDate) }}
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
              {{ content?.["b2b.managetraveler.actions"] }}
            </th>
            <td mat-cell *matCellDef="let element" class="onclick-links">
              <a tabindex="0" role="button" class="onclick-cell primary-link" (click)="openPassportDetails(element)">{{content?.["b2b.managetraveler.edit"] }}</a>
              <!-- <a class="onclick-cell warm-link" *ngIf="!Addnew"
                                (click)="deleteThisCard(element.id)">Remove</a> -->
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns1"></tr>
        </table>
      </div>

      <!-- TSA Precheck Table -->

      <div class="precheck-cntr" *ngIf="dataSourcePreCheck?.data?.length && !Addnew">
        <div class="section-heading">
          <h2 class="h2-heading">{{content?.['b2b.managetraveler.tsaprecheckdetails'] || 'TSA Precheck details'}}</h2>
        </div>
        <div class="section-table data-listing">
          <table mat-table [dataSource]="dataSourcePreCheck">
            <ng-container matColumnDef="tsaPrecheck">
              <th mat-header-cell *matHeaderCellDef>{{content?.['b2b.managetraveler.tsaprecheck'] || 'TSA Precheck'}}</th>
              <td mat-cell *matCellDef="let element">
                {{
                element.docType?.toUpperCase() === "T"
                ? "TSA Precheck / Known Traveler number"
                : element.docType?.toUpperCase() === "R"
                ? "Redress Number"
                : ""
                }}
              </td>
            </ng-container>
            <ng-container matColumnDef="documentNumber">
              <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managetraveler.docnumber']}}</th>
              <td mat-cell *matCellDef="let element" data-dd-privacy="mask">
                {{ element.docNo }}
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>{{approvalContent?.['b2b.manageapproval.actions'] || 'Actions'}}</th>
              <td mat-cell *matCellDef="let element" class="onclick-links">
                <a tabindex="0" role="button" aria-label="Edit item" class="onclick-cell primary-link" (keydown.enter)="openPassportDetails(element)" (click)="openPassportDetails(element)">
                  <mat-icon fontSet="material-symbols-outlined">edit</mat-icon>
                </a>
                <a tabindex="0" role="button" aria-label="Remove item" class="onclick-cell warm-link" (keydown.enter)="deleteThisCard(element.id)" (click)="deleteThisCard(element.id)">
                  <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
                </a>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="preCheckColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: preCheckColumns"></tr>
          </table>
        </div>
      </div>
      <!-- TSA Precheck Table end -->
    </div>
    <div class="inner-action" *ngIf="(dataSource1.data.length == 0 && canShowDocumentActions) || Addnew">
      <button mat-button type="button" class="button--secondary-small" (click)="Cancel()">
        {{ content?.["b2b.managetraveler.cancel"] }}
      </button>
      <button mat-button class="button--primary-small" [class.disabled]="documentinfoForm.invalid || Loader.isSpinner" (click)="onSave()">
        <mat-spinner class="button" *ngIf="Loader.isSpinner"></mat-spinner>
        {{ content?.["b2b.managetraveler.save"] }}
      </button>
    </div>
  </div>
</form>


<ng-template #selectionWarning>
  <div class="custom-dialog">
    <div class="d-justify-bw">
      <div class="custom-dialog__left">
        <div class="mat-dialog-title custom-dialog__title d-justify-bw">
          <h2 class="mat-dialog-title"> {{content?.dictionary?.['b2b.global.namemismatch'] || 'Name mismatch'}}</h2>
          <div class="custom-overlay-close">
            <mat-icon fontSet="material-symbols-outlined" class="close_icon" role="button" tabindex="0" aria-label="close dialog" (keydown.enter)="CloseDialog(false)" (keyup.space)="CloseDialog(false)"
              (click)="CloseDialog(false)">close</mat-icon>
          </div>
        </div>
        <mat-dialog-content class="custom-dialog__title_content top_border_none">
          <div class="custom-dialog__description">
            {{content?.['b2b.managetraveler.profilenamedifffromdoc'] || "Your profile name is different from the document. If you continue we'll update as per document"}}
            </div>
        </mat-dialog-content>
        <mat-dialog-content class="custom-dialog__text">
          <div class="custom-dialog__inner_text"><span>{{content?.['b2b.managetraveler.nameonprofile'] || 'Name on profile'}}-</span> <span data-dd-privacy="mask">{{profileName}}</span></div>
          <div class="custom-dialog__inner_text"><span>{{content?.['b2b.managetraveler.nameondoc'] || 'Name on document'}}-</span> <span data-dd-privacy="mask">{{docName}}</span></div>
        </mat-dialog-content>
        <mat-dialog-actions>
          <div class="dialog-actions-right">
            <button class="button--secondary-small" mat-button (click)="CloseDialog(false)">{{content?.['b2b.managetraveler.cancel'] || 'Cancel'}}</button>
            <button class="button--primary-small" mat-button
              (click)="onContinueAfterMismatch()">
              {{content?.['b2b.managetraveler.continue'] || 'Continue'}}
            <mat-spinner class="button" *ngIf="Loader.isSpinner"></mat-spinner>
            </button>
          </div>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>